import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/images/Praxiti-Logo.png';

const headerNav = [
  { name: 'Solutions', url: '#solutions-praxiti-header' },
  { name: 'About Us', url: '#about-us-header-praxiti' },
  { name: 'Contact', url: '#contact-us-header-praxiti' },
  { name: 'Careers', url: '/careers' },
];

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('.main-header');
      if (window.scrollY > 40) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // check if navigation has scroll target
    if (location.state?.scrollTo) {
      const targetId = location.state.scrollTo;
      const element = document.getElementById(targetId);
      console.log({ element });
      console.log({ targetId });
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const handleAnchorClick = (e, targetId) => {
    e.preventDefault();

    if (location.pathname === '/') {
      // already on home → scroll directly
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // not on home → navigate to home and send targetId
      navigate('/', { state: { scrollTo: targetId } });
    }
  };
  
  const handleLogoClick = (e) => {
  e.preventDefault();
 
  if (location.pathname === '/') {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  } else {
    navigate('/');
  }
 
  setMenuOpen(false);
};

  return (
    <header className="main-header">
      <div className="container">
        <div className="logo">
          <NavLink to="/">
            <a href="/" onClick={handleLogoClick}>
              <img
                 src={logo}
                 alt="Praxiti Logo"
                 className="header-logo-img"
              />
            </a>
          </NavLink>
        </div>

        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle Menu"
        >
          {menuOpen ? '✖' : '☰'}
        </button>

        <nav className={`main-nav ${menuOpen ? 'open' : ''}`}>
          <ul>
            {headerNav.map((item, index) => (
              <li key={index}>
                {item.url.startsWith('#') ? (
                  <a
                    href={item.url}
                    onClick={e =>
                      handleAnchorClick(e, item.url.replace('#', ''))
                    }
                  >
                    {item.name}
                  </a>
                ) : (
                  <NavLink to={item.url} onClick={() => setMenuOpen(false)}>
                    {item.name}
                  </NavLink>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
